import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetDynamicPage from '@/modules/client-setting/api/hooks/useQueryGetDynamicPage'
import DynamicPageListing from '@/modules/client-setting/components/DynamicPage/components/DynamicPageListing'

function DynamicPage() {
	const { pageSize, currentPage } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
	}

	const { data, isLoading } = useQueryGetDynamicPage(payload)

	return (
		<PageContainer>
			<DynamicPageListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedDynamicPage = withUserPermission(DynamicPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedDynamicPage
